export default function Menu() {
    // Change menu color on scroll
    document.addEventListener("scroll", function () {
        const element = document.getElementById("header");
        const scrollPosition = window.scrollY || window.pageYOffset;

        if (scrollPosition > 300) {
          element.classList.add("active");
        } else if (scrollPosition <= 0) {
          element.classList.remove("active");
        }
      });



      //elements select
      const backgroundCloseMneu = document.querySelector('.container-menu-background')
      const menuBtn = document.querySelector('.menu-btn');
      const menu = document.querySelector('#menu');
      const body = document.querySelector('body');
      const header = document.getElementById("header");
      const closeMenu = document.querySelector('.close-menu');

      //active menu on btn
      menuBtn.addEventListener('click', () => {
        menuOpen();
      });

      backgroundCloseMneu.addEventListener('click', () => {
        menuBtn.classList.remove('active')
        body.classList.remove('active');
        backgroundCloseMneu.classList.remove('active');
        menu.classList.remove('active');

        tl.reverse(1.4)
    })

      closeMenu.addEventListener('click', () => {
        menuBtn.classList.remove('active')
        body.classList.remove('active');
        backgroundCloseMneu.classList.remove('active');
        menu.classList.remove('active');

        tl.reverse(1.4)
      });

      var tl = gsap.timeline();

      function menuOpen(){
        if(menu.classList.contains('active')){
            menu.classList.remove('active');
            backgroundCloseMneu.classList.remove('active');
            body.classList.remove('active');

            tl.reverse(1.4)
            scrollPosition > 300 ? header.classList.add('active') : header.classList.remove('active')

            } else{
                menu.classList.add('active');
                backgroundCloseMneu.classList.add('active');
                body.classList.add('active');
                header.classList.add('active');
                tl.play()
                tl.to("#menu", {
                    duration: 1,
                    "--clip": '0% 0% 0%',
                    opacity: 1,
                    visibility: 'inherit',
                    ease: Power4.easeOut,
                })
            }
    }

    //search menu
    const contentSeach = document.querySelector('.search-menu');
    const btnOpenSearch = document.querySelector('.search-btn');
    const btnCloseSearch = document.querySelector('.btn-close-search');
    const links = document.querySelectorAll('.remove-in-search');
    const inputSearch = document.querySelector('#searh-products');

      //Timelines
      let searchTimeline = gsap.timeline({ paused: true });
      searchTimeline.to(links, {
          x: 20,
          opacity: 0,
          display: 'none'
      });
      searchTimeline.to(contentSeach, {
          duration: 1,
          opacity: 1,
          width: '80%',
          display: 'flex',
      }, '<+1');

      btnOpenSearch.addEventListener("click", () => {
          searchTimeline.play()

          setTimeout(() => {
              inputSearch.focus({ preventScroll: true });
          }, 1500)

      })

      btnCloseSearch.addEventListener("click", () => {
          searchTimeline.reverse()
      })



}
